import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row, InputGroup } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, reset_formato_rut, validaNumeros } from '../../../common/Formatos'
import { obtenerRutConductor, obtenerRutDestinatario } from '../../../store/actions/implicado-action'

const Conductor = ({ formik, setRutConductorFinal, isImplicado, handleShowProp, setHandleShowProp }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais, comboComunas, cfg_form37, comboDestinatario, comboMedioPago, comboInstitucion, comboTipoCuenta } = data_datos_implicado


  const [tipoDestinatario, setTipoDestinatario] = useState("")
  const [rutDestinatario, setRutDestinatario] = useState('')
  const [rutDestinatarioNoFormato, setRutDestinatarioNoFormato] = useState('')
  const [nombreDestinatario, setNombreDestinatario] = useState('')
  const [emailDestinatario, setEmailDestinatario] = useState('')
  const [medioPago, setMedioPago] = useState('')
  const [institucion, setInstitucion] = useState('')
  const [tipoCuenta, setTipoCuenta] = useState('')
  const [numeroCuenta, setNumeroCuenta] = useState('')
  //viejo
  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [rutConductor, setRutConductor] = useState('')
  const [rutConductorNoFormato, setRutConductorNoFormato] = useState('')
  const [nombreConductor, setNombreConductor] = useState('')
  const [direccionConductor, setDireccionConductor] = useState('')
  const [emailConductor, setEmailConductor] = useState('')
  const [paisConductor, setPaisConductor] = useState('')
  const [paisMovilConductor, setPaisMovilConductor] = useState('')
  const [fonoConductor, setFonoConductor] = useState('')
  const [movilConductor, setMovilConductor] = useState('')
  const [comunaConductor, setComunaConductor] = useState('')
  const [ciudadConductor, setCiudadConductor] = useState('')


  const distpatch = useDispatch()
  useEffect(() => {

    distpatch(obtenerRutDestinatario(rutDestinatarioNoFormato))
  }, [rutDestinatarioNoFormato])

  useEffect(() => {
    setRutDestinatario('');
    setRutDestinatarioNoFormato('');
    setNombreDestinatario('');
    setEmailDestinatario('');
    setMedioPago('');
    setInstitucion('');
    setTipoCuenta('');
    setNumeroCuenta('');
    setTipoDestinatario('');

    setHandleShowProp(false);
  }, [handleShowProp])

  useEffect(() => {
    if (!isImplicado && datosPantalla?.datosPantalla[0]) {

      setTipoDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['TipoDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['TipoDestinatario'] !== null && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== 0
          ?
          datosPantalla.datosPantalla[0]['TipoDestinatario']
          : ''
      )
      setRutDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== null
          ? formato_rut(
            datosPantalla.datosPantalla[0]['RutDestinatario'])
          : ''
      )

      setRutDestinatarioNoFormato(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['RutDestinatario']
          : ''
      )
      setNombreDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario']
          : ''
      )
      setEmailDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['EmailDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['EmailDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['EmailDestinatario']
          : ''
      )
      setMedioPago(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['MedioPago'] !== undefined &&
          datosPantalla.datosPantalla[0]['MedioPago'] !== null && datosPantalla.datosPantalla[0]['MedioPago'] !== 0
          ?
          datosPantalla.datosPantalla[0]['MedioPago']
          : ''
      )
      setInstitucion(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== null && datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== 0
          ?
          datosPantalla.datosPantalla[0]['InstitucionFinanciera']
          : ''
      )
      setTipoCuenta(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera'] !== null && datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== 0
          ?
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera']
          : ''
      )
      setNumeroCuenta(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera'] !== null
          ?
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera']
          : ''
      )

      if (datosPantalla && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== undefined &&
        datosPantalla.datosPantalla[0]['TipoDestinatario'] !== null && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== "" && datosPantalla.datosPantalla[0].TipoDestinatario === 260001) {
        formik.values.rutDestinatario = datosPantalla.datosPantalla[0].RutImplicado;
        formik.values.nombreDestinatario = datosPantalla.datosPantalla[0].NombreImplicado;
        formik.values.emailDestinatario = datosPantalla.datosPantalla[0].EmailImplicado;
      }
    }


  }, [datosPantalla])

  useEffect(() => {
    if (formik.values.tipoDestinatario === 260001 || formik.values.tipoDestinatario === "260001") {
      formik.values.rutDestinatario = formik.values.rutImplicado;
      formik.values.nombreDestinatario = formik.values.nombreImplicado;
      formik.values.emailDestinatario = formik.values.emailImplicado;
    }
  }, [formik.values.rutImplicado, formik.values.nombreImplicado, formik.values.emailImplicado])

  return (
    <>
      {/* <Container> */}
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form37
            ? cfg_form37.cfg_form37[
            'casograldefensa-editimpl-title-dest-pago'
            ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form37 ? (
            <div>
              <Row>

                <Col>
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-tipodest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setTipoDestinatario(e.target.value)

                      if (e.target.value !== "260001") {
                        setRutDestinatario("")
                        setNombreDestinatario("")
                        setEmailDestinatario("")
                        setRutDestinatarioNoFormato("")
                      }
                    }}
                    name='tipoDestinatario'
                    value={(formik.values.tipoDestinatario = tipoDestinatario)}
                    error={formik.errors.tipoDestinatario}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboDestinatario &&
                      comboDestinatario.comboDestinatario?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.tipoDestinatario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoDestinatario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-rutdest'
                      ]
                    }
                  </Form.Label>{' '}
                  <br />
                  {!isImplicado && formik.values.tipoDestinatario == "260001" ?
                    <Form.Text className='mb-3'>
                      {formik.values.rutImplicado && formik.values.rutImplicado !== 'undefined' ? formik.values.rutImplicado : ''}
                    </Form.Text> :
                    isImplicado && formik.values.tipoDestinatario == "260001" ?
                      <Form.Text className='mb-3'>
                        {formik.values.rutImplicadoTercero && formik.values.rutImplicadoTercero !== 'undefined' ? formik.values.rutImplicadoTercero : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          autoComplete='off'
                          value={
                            (formik.values.rutDestinatario =
                              rutDestinatario !== undefined && rutDestinatario)
                          }
                          onChange={(e) => {
                            formik.handleChange(e)
                            setRutDestinatario(e.target.value)
                            setRutDestinatarioNoFormato(e.target.value)
                          }}
                          onFocus={() =>
                            setRutDestinatario(rutDestinatarioNoFormato)
                          }
                          onBlur={() => {
                            setRutDestinatario(formato_rut(rutDestinatario))
                          }}
                          name='rutDestinatario'
                          error={formik.errors.rutDestinatario}
                        ></Form.Control>
                        {formik.errors.rutDestinatario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.rutDestinatario}
                          </Form.Text>
                        ) : ('')}
                      </>
                  }
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-nomdest'
                      ]
                    }
                  </Form.Label>
                  <br />

                  {!isImplicado && formik.values.tipoDestinatario == "260001" ?
                    <Form.Text className='mb-3'>
                      {formik.values.nombreImplicado && formik.values.nombreImplicado !== 'undefined' ? formik.values.nombreImplicado : ''}
                    </Form.Text> :
                    isImplicado && formik.values.tipoDestinatario == "260001" ?
                      <Form.Text className='mb-3'>
                        {formik.values.nombreInvolucradoTercero && formik.values.nombreInvolucradoTercero !== 'undefined' ? formik.values.nombreInvolucradoTercero : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          value={
                            (formik.values.nombreDestinatario =
                              nombreDestinatario !== undefined && nombreDestinatario)
                          }
                          onChange={(e) => {
                            formik.handleChange(e)
                            setNombreDestinatario(e.target.value)
                          }}
                          name='nombreDestinatario'
                          error={formik.errors.nombreDestinatario}
                        ></Form.Control>
                        {formik.errors.nombreDestinatario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.nombreDestinatario}
                          </Form.Text>
                        ) : ('')}
                      </>
                  }
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-emaildest'
                      ]
                    }
                  </Form.Label>
                  <br />

                  {formik.values.tipoDestinatario == "260001" ?
                    <Form.Text className='mb-3'>
                      {formik.values.emailImplicado && formik.values.emailImplicado !== 'undefined' ? formik.values.emailImplicado : ''}
                    </Form.Text> :
                    <>
                      <Form.Control
                        className='mt-2'
                        value={
                          (formik.values.emailDestinatario =
                            emailDestinatario !== undefined && emailDestinatario)
                        }
                        onChange={(e) => {
                          formik.handleChange(e)
                          setEmailDestinatario(e.target.value)
                        }}
                        name='emailDestinatario'
                        error={formik.errors.emailDestinatario}
                      ></Form.Control>
                      {formik.errors.emailDestinatario ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.emailDestinatario}
                        </Form.Text>
                      ) : ('')}
                    </>
                  }
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-mediopagodest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)

                      setMedioPago(e.target.value)
                    }}
                    name='medioPago'
                    value={(formik.values.medioPago = medioPago)}
                    error={formik.errors.medioPago}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboMedioPago &&
                      comboMedioPago.comboMedioPago?.filter(m => m.agrupacion === 1).map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.medioPago ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.medioPago}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-instfinandest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setInstitucion(e.target.value)
                    }}
                    name='institucion'
                    value={(formik.values.institucion = institucion)}
                    error={formik.errors.institucion}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboInstitucion &&
                      comboInstitucion.comboInstitucion?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.institucion ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.institucion}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>

                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-tipoctadest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setTipoCuenta(e.target.value)
                    }}
                    name='tipoCuenta'
                    value={(formik.values.tipoCuenta = tipoCuenta)}
                    error={formik.errors.tipoCuenta}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboTipoCuenta &&
                      comboTipoCuenta.comboTipoCuenta?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.tipoCuenta ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoCuenta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col>
                  <Form.Label
                    className='mt-2 mb-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-nroctadest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2 w-75 mb-3'
                    autoComplete='off'
                    value={
                      (formik.values.numeroCuenta =
                        numeroCuenta !== undefined && numeroCuenta)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setNumeroCuenta(e.target.value)

                    }}

                    name='numeroCuenta'
                    error={formik.errors.numeroCuenta}
                  ></Form.Control>
                  {formik.errors.numeroCuenta ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.numeroCuenta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Conductor
